import { render } from "./AddonViewFullTextList.vue?vue&type=template&id=49c8a468&scoped=true&ts=true"
import script from "./AddonViewFullTextList.vue?vue&type=script&lang=ts"
export * from "./AddonViewFullTextList.vue?vue&type=script&lang=ts"

import "./AddonViewFullTextList.vue?vue&type=style&index=0&id=49c8a468&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c8a468"]])

export default __exports__